import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextInput from "./TextInput";
import FittingInformationDialog from "./FittingInformationDialog";

const FittingInformation = ({ dataFilled }) => {
	const [openDialog, setOpenDialog] = useState(false);
	var sessionId = localStorage.getItem("sessionId");
	var fitterName = localStorage.getItem("fitterName");
	var locationId = localStorage.getItem("locationId");
	var rightHanded = localStorage.getItem("rightHanded");
	var clubType = localStorage.getItem("clubType");

	useEffect(() => {
		if (sessionId && fitterName && locationId && rightHanded && clubType) {
			dataFilled(true);
		}
		// Check if continuing session and auto-open modal
		const continueSession = localStorage.getItem("continueSession");
		if (continueSession === "true") {
			setOpenDialog(true);
			localStorage.removeItem("continueSession");
		}
	}, []);
	return (
		<Grid container>
			<Grid item xs={12} display="flex">
				<Typography variant="h4">Fitting Information</Typography>
				<Button
					sx={{ marginLeft: 2 }}
					variant="contained"
					onClick={() => setOpenDialog(true)}
				>
					{sessionId && fitterName && locationId && rightHanded && clubType
						? "Update Session Info"
						: "Set Session Info"}
				</Button>
			</Grid>
			{sessionId && fitterName && locationId && rightHanded && clubType ? (
				<Grid item xs={12} display="flex">
					<TextInput
						label="Fitter Name"
						value={fitterName}
						variant="filled"
						InputProps={{
							disableUnderline: true,
							style: { borderRadius: "4px" },
						}}
						inputProps={{
							style: { paddingTop: "15px" },
						}}
						sx={{ paddingRight: 2 }}
						disabled
					/>
					<TextInput
						label="Location ID"
						value={locationId}
						variant="filled"
						InputProps={{
							disableUnderline: true,
							style: { borderRadius: "4px" },
						}}
						inputProps={{
							style: { paddingTop: "15px" },
						}}
						sx={{ paddingRight: 2 }}
						disabled
					/>
					<TextInput
						label="Dexterity"
						value={rightHanded ? "Right" : "Left"}
						variant="filled"
						InputProps={{
							disableUnderline: true,
							style: { borderRadius: "4px" },
						}}
						inputProps={{
							style: { paddingTop: "15px" },
						}}
						sx={{ paddingRight: 2, width: "80px" }}
						disabled
					/>
					<TextInput
						label="Club Type"
						value={clubType}
						variant="filled"
						InputProps={{
							disableUnderline: true,
							style: { borderRadius: "4px" },
						}}
						inputProps={{
							style: { paddingTop: "15px" },
						}}
						sx={{ paddingRight: 2, width: "80px" }}
						disabled
					/>
				</Grid>
			) : null}
			<FittingInformationDialog
				open={openDialog}
				dialogControl={setOpenDialog}
				dataFilled={dataFilled}
			/>
		</Grid>
	);
};

export default FittingInformation;
